import {useTranslation} from '@/translations/i18n'
import {InputSelectUser, UserSmallSelection} from '@/features/users/components/input-select-user/InputSelectUser'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '../../types'
import {useGetUser} from '@/features/users/queries/useGetUser'
import {useAccessesAccordion} from '../accesses-accordion-context-provider/AccessesAccordionContextProvider'

export const AccessesValidatorUserFilter = () => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(ValidatorSearchParams)
    const {collapseAll} = useAccessesAccordion()
    const {data: selectedUser, isLoading: isSelectedUserLoading} = useGetUser({
        userId: searchParams.consultant,
        responseType: 'small',
        options: {enabled: !!searchParams.consultant}
    })

    const onChange = (user: UserSmallSelection | null) => {
        setSearchParams({consultant: user?.id})
        collapseAll()
    }

    const onClear = () => {
        setSearchParams({consultant: undefined, startDate: undefined, endDate: undefined, patient: undefined})
        collapseAll()
    }

    return (
        <InputSelectUser
            label={t('commons:operator')}
            value={selectedUser ?? null}
            onChange={onChange}
            placeholder="Seleziona operatore"
            isLoading={isSelectedUserLoading}
            onClear={onClear}
        />
    )
}
